import React from 'react';
import PropTypes from 'prop-types';

import Popup from 'components/Popup';

export default function AMTPopup({ isPopupOpen, setIsPopupOpen }) {
  const closePopup = () => setIsPopupOpen(false);

  return (
    isPopupOpen && (
      <Popup closePopup={closePopup}>
        <h2 className='mb-4'>How do I calculate my AMT?</h2>
        <p>
          To calculate your AMT (alternative minimum tax), take the difference between the FMV at the time of exercise (their valuation at
          the time of exercising) and the grant price (the original price of your shares, i.e. what you bought your shares for). This is
          your AMT’s spread. It is treated as income and can increase your tax liability. Refer to form 6251 to calculate your exact AMT.
        </p>
      </Popup>
    )
  );
}

AMTPopup.propTypes = {
  isPopupOpen: PropTypes.bool,
  setIsPopupOpen: PropTypes.func
};
